import { Type } from 'class-transformer';
import {
	ArrayMaxSize,
	ArrayMinSize,
	IsArray,
	IsBoolean,
	IsEnum,
	IsNotEmpty,
	IsOptional,
	IsString,
	ValidateIf,
	ValidateNested,
} from 'class-validator';
import {
	AttendeeRegistrationFieldTypeEnum,
	FieldTypeWithOptionsList,
	maxFieldOptions,
	minFieldOptions
} from '../../constants';

export enum TiersTypeEnum {
	All = 'all',
	Selected = 'selected',
}

export class AttendeeRegistrationReservedFieldFormDto {
	@ValidateIf((o: AttendeeRegistrationReservedFieldFormDto) => o.enabled)
	@IsString()
	@IsNotEmpty()
	public label?: string;

	@ValidateIf((o: AttendeeRegistrationReservedFieldFormDto) => o.enabled)
	@IsBoolean()
	@IsNotEmpty()
	public required?: boolean;

	@IsBoolean()
	@IsNotEmpty()
	public enabled: boolean;
}

export class AttendeeRegistrationFieldOptionFormDto {
	@IsNotEmpty()
	@IsString()
	public id: string;

	@IsNotEmpty({ message: 'Enter a option' })
	@IsString()
	public name: string;
}

export class AttendeeRegistrationFieldFormDto {
	@IsNotEmpty({ message: 'Enter a question' })
	@IsString()
	public question: string;

	@IsEnum(AttendeeRegistrationFieldTypeEnum)
	@IsNotEmpty()
	public type: AttendeeRegistrationFieldTypeEnum;

	@IsBoolean()
	public required: boolean;

	@ValidateIf((o: AttendeeRegistrationFieldFormDto) => FieldTypeWithOptionsList.includes(o.type))
	@IsArray()
	@ArrayMinSize(minFieldOptions)
	@ArrayMaxSize(maxFieldOptions)
	@ValidateNested({ each: true })
	@Type(() => AttendeeRegistrationFieldOptionFormDto)
	public options?: AttendeeRegistrationFieldOptionFormDto[];

	@ValidateIf((o: AttendeeRegistrationFieldFormDto) => o.tiersType === TiersTypeEnum.Selected)
	@IsArray()
	@ArrayMinSize(1)
	public tierIds?: Array<string>;

	@IsNotEmpty()
	@IsEnum(TiersTypeEnum)
	public tiersType: TiersTypeEnum;

	@IsOptional()
	@IsString()
	public name?: string;

	@IsOptional()
	@IsBoolean()
	public isCommonForAllTickets?: boolean;

	@IsOptional()
	@IsString()
	public label?: string;

	@IsOptional()
	@IsString()
	public checkboxLabel?: string;

	@IsOptional()
	@IsString()
	public placeholder?: string;

	@IsOptional()
	@IsString()
	public defaultValue?: string;

	@IsOptional()
	@IsString()
	public textInputType?: 'text' | 'email' | 'phone-number' | 'number';

	@IsOptional()
	@IsString()
	public validateIsEqualToField?: string;
}

export class AttendeeRegistrationFormDto {
	@IsBoolean()
	public isReservedFieldsRequires: boolean;

	@ValidateIf((o: AttendeeRegistrationFormDto) => o.isReservedFieldsRequires)
	@IsNotEmpty()
	public emailReservedField?: AttendeeRegistrationReservedFieldFormDto;

	@ValidateIf((o: AttendeeRegistrationFormDto) => o.isReservedFieldsRequires)
	@IsNotEmpty()
	public fullNameReservedField?: AttendeeRegistrationReservedFieldFormDto;

	@ValidateIf((o: AttendeeRegistrationFormDto) => o.isReservedFieldsRequires)
	@IsNotEmpty()
	public phoneReservedField?: AttendeeRegistrationReservedFieldFormDto;

	@IsOptional()
	public showSectionsOnceForMultipleTickets?: boolean;

	@IsArray()
	@IsNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => AttendeeRegistrationFieldFormDto)
	public fields: AttendeeRegistrationFieldFormDto[];
}
